import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import Continue from '../../assets/Continue.png';
import IconPath from '../../assets/QuestionMark.svg';

interface CoachingShoutoutAttentionDiaProps {
    visible: boolean;
    onHide: () => void;
    onContinue?: () => void;
}

export const CoachingShoutoutAttentionDia: React.FC<CoachingShoutoutAttentionDiaProps> = ({
    visible,
    onHide,
    onContinue    
}) => {
    const handleContinue = () => {
        if (onContinue) {
            onContinue();
        }
        onHide();
    };

    const footerContent = (
        <div style={{ display: 'flex', justifyContent: 'center', gap: '12px' }}>
            <Button
                label="Close"
                icon="pi pi-times"
                className="btn-secondary"
                // style={{
                //     borderRadius: '30px',
                //     borderColor: '#EB419E',
                //     color: '#EB419E',
                // }}
                onClick={onHide}
            />
            <Button
                className="btn-primary"
                // style={{
                //     background: 'linear-gradient(to right, #F069DE, #6a3dfb)',
                //     borderColor: 'linear-gradient(to right, #F069DE, #6a3dfb)',
                //     borderRadius: '30px',
                // }}
                onClick={handleContinue}
            >
                <img src={Continue} alt="icon" style={{ width: '16px', height: '16px' }} />
                <span style={{ marginLeft: '8px', fontWeight: 400 }}>Continue</span>
            </Button>
        </div>
    );

    return (
        <Dialog
            visible={visible}
            onHide={onHide}
            footer={footerContent}
            closable={false}
            style={{ width: '550px', borderRadius: '12px' }}
        >
            <div style={{ textAlign: 'center', padding: '1rem' }}>
                <img
                    className="notification-icon"
                    style={{ width: '48px', height: '48px', margin: '0 auto 10px' }}
                    src={IconPath}
                    alt={IconPath}
                />

                <h3 style={{ marginBottom: '0.5rem', color: '#7a3eff' }}>Attention</h3>

                <p style={{ fontSize: '20px', marginBottom: '2rem', lineHeight: '1.4' }}>
                    To leave Comments and/or Reactions,
                    <br />
                    you will be redirected to <em style={{ fontStyle: 'italic' }}>Awardco</em>
                </p>
            </div>
        </Dialog>
    );
};
